import React from "react";

export default function SevenDayBars({ days }) {
  // days: [{ label: "Wed", count: 3 }, ...] length 7
  const max = Math.max(1, ...days.map((d) => d.count));

  return (
    <div style={{ display: "grid", gap: 10 }}>
      <div style={{ fontWeight: 900 }}>Last 7 days</div>

      <div style={wrap}>
        {days.map((d) => {
          const h = Math.round((d.count / max) * 44);
          return (
            <div key={d.label} style={col}>
              <div style={barBg}>
                <div style={{ ...barFill, height: `${h}px` }} />
              </div>
              <div style={lab}>{d.label}</div>
              <div style={cnt}>{d.count}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const wrap = {
  display: "grid",
  gridTemplateColumns: "repeat(7, 1fr)",
  gap: 10,
  alignItems: "end",
};

const col = { display: "grid", gap: 6, justifyItems: "center" };

const barBg = {
  width: "100%",
  height: 48,
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.12)",
  background: "rgba(255,255,255,0.05)",
  display: "flex",
  alignItems: "flex-end",
  overflow: "hidden",
};

const barFill = {
  width: "100%",
  background: "rgba(255,255,255,0.35)",
};

const lab = { fontSize: 12, opacity: 0.8 };
const cnt = { fontSize: 12, opacity: 0.8 };
